export const environment = {
  socketBase: `https://hermes.horseracing.software/stewards`,
  apiBase: `https://stewards-api.horseracing.software`,
  authUrl: 'https://auth.horseracing.software',
  rioBase: `https://rio.horseracing.software`,
  ricoBase: `https://rico.horseracing.software`,
  tenantId: 'd573861a-eab0-4851-bcf8-e9ef40097061',
  production: true
};
